export const BANNER_PADDINGS = {
  SIZE_10: '--banner-paddings-size-10', // Homepage
  SIZE_20: '--banner-paddings-size-20', // TV Series
  SIZE_30: '--banner-paddings-size-30', // Movies
  SIZE_40: '--banner-paddings-size-40', // TV Channels
  SIZE_50: '--banner-paddings-size-50', // Details Pages
  SIZE_60: '--banner-paddings-size-60', // LiveEventDetail Pages
  PARTNER_PROGRAM_DETAILS_PAGE:
    '--banner-paddings-partner-program-details-page', // PartnerProgramDetails Pages
  DETAILS_PAGE: '--banner-paddings-details-page',
} as const
export type BANNER_PADDINGS =
  (typeof BANNER_PADDINGS)[keyof typeof BANNER_PADDINGS]
